import { useState, useEffect, useCallback } from 'react';
import constate from 'constate';
export const useWindowSizeContext = constate(() => {
    const [state, setState] = useState({
        width: window ? window.innerWidth : Infinity,
        height: window ? window.innerHeight : Infinity,
    });
    const set = useCallback((event) => setState({ width: window.innerWidth, height: window.innerHeight }), []);
    useEffect(() => {
        window.addEventListener('resize', set);
        return () => window.removeEventListener('resize', set);
    }, [set]);
    return state;
});
export const useParentSizeContext = constate(() => {
    const [state, setState] = useState({
        width: window ? window.parent.innerWidth : Infinity,
        height: window ? window.parent.innerHeight : Infinity,
    });
    const set = useCallback((event) => setState({ width: window.parent.innerWidth, height: window.parent.innerHeight }), []);
    useEffect(() => {
        window.addEventListener('resize', set);
        return () => window.removeEventListener('resize', set);
    }, [set]);
    return state;
});
//# sourceMappingURL=WindowSizeContext.js.map